import React from 'react';
import "../styles/PrivacyPolicy.css"
import NavBar from './NavBar';
import SideBar from './SideBar';

const PrivacyPolicy = () => {
  return (
    <>     
     <div className="nav_style">
            <NavBar />
            <SideBar />
      </div>
      <div className="privacy-container">
        <div className="privacy-content">
          <h1 className="privacy-title">Privacy Policy</h1>

          {/* Introduction */}
          <section className="section">
            <p>
              This privacy policy is an electronic record in the form of an electronic contract formed under the Rule 3 of the Information Technology Act, 2000 and the Rules made thereunder and the amended provisions pertaining to electronic documents/records in various statutes as amended by the Information Technology Act, 2000. This privacy policy does not require any physical, electronic, or digital signature.
            </p>
            <p>
              Please read this document carefully. By using the Mobile Application/Website, you indicate that you understand, agree, and consent to this privacy policy. If you do not agree with the terms of this privacy policy, please do not use this Mobile Application/Website. You hereby provide your unconditional/explicit consent or agreements to Sharada Stores as provided under Section 43A and Section 72A of Information Technology Act, 2000.
            </p>
            <p>
              By using our services, you explicitly consent to the collection, recording, organization, structuring, storage, adaptation, retrieval, use, alignment or combination, indexing, sharing, disclosure by transmission, dissemination, or otherwise making available, restriction, erasure, or destruction of your personal data, as outlined in this Privacy Policy. We ensure that all personal data provided by you is processed in accordance with applicable data protection laws, including the Data Protection and Privacy Act (DPDP Act).
            </p>
            <p>
              You have the right to request the erasure of your personal data, or to withdraw your consent for the processing of your personal data at any time. Such requests can be made by sending an email to Sharada Stores. Upon receipt of such a request, we will take necessary actions in accordance with the DPDP Act, subject to any applicable legal obligations or requirements.
            </p>
            <p>
              Please note that withdrawing your consent or requesting the erasure of data may impact your ability to use certain services that require processing of personal data.
            </p>
          </section>

          {/* Section 1: Your Privacy */}
          <section className="section">
            <h2>1. Your Privacy</h2>
            <p>
              <span className="bold">1.1.</span> Your privacy is important to us and we want you to know what information, including your personal and other information, we collect about you and from you and how we use that information. Personal information may be specified as the information that includes names, addresses, e-mail IDs, telephone number, mode of payment, etc.
            </p>
            <p>
              <span className="bold">1.2.</span> When someone visits our Mobile Application/Website, our webservers automatically gather information that allows the Mobile Application/Website to communicate with the visitor's computer or device during the visit. We also collect information such as the number of visits to the Mobile Application/Website, which parts of the Mobile Application/Website visitors select, IP address, domain type, date, and time of day. We use such information only for statistical purposes that help us design and administer the site.
            </p>
            <p>
              <span className="bold">1.3.</span> This privacy policy provides information on the processing of your personal data as a result of being:
              <ul>
                <li>One of our customers,</li>
                <li>A visitor to the Mobile Application/Website, and/or</li>
                <li>A user of the Mobile Application/Website.</li>
              </ul>
            </p>
            <p>
              <span className="bold">1.4.</span> Because we're always looking for new and innovative ways to help you build meaningful connections, this policy may change over time. We request you to update yourself by accessing this Privacy Policy frequently.
            </p>
          </section>

          {/* Section 2: Applicability */}
          <section className="section">
            <h2>2. Applicability</h2>
            <p>
              <span className="bold">2.1.</span> This Privacy Policy provides information on the processing of your personal data as a result of being:
              <ul>
                <li>One of our customers, including but not limited to our Mobile Application/Website users, etc., and</li>
                <li>A guest visitor to the Mobile Application/Website.</li>
              </ul>
            </p>
            <p>
              <span className="bold">2.2.</span> This Privacy Policy applies to websites, applications, events, and other services operated by Sharada Stores. All of these are together defined as Mobile Application/Website/services offered by Sharada Stores ("Services") in this Privacy Policy.
            </p>
          </section>

          {/* Section 3: Information We Collect */}
          <section className="section">
            <h2>3. Information We Collect</h2>
            <p>
              Collection of your information is pertinent to provide you the services offered by us. We also collect information generated as you use our services. Details of information we collect include but are not limited to Name, addresses, phone number, email id.
            </p>
          </section>

          {/* Section 4: Need for Your Information */}
          <section className="section">
            <h2>4. Need for Your Information</h2>
            <p>
              We need your personal information for the following services:
            </p>
            <p>
              <span className="bold">4.1. Development and Improvement of Services Offered</span><br />
              We regularly conduct market research with our customers. We use your personal information for quality assessments and to improve your customer experience.
            </p>
            <p>
              <span className="bold">4.2. Offers and Other Information</span><br />
              As our customer, user of the Mobile Application/Website, you may receive general offers and information from us, including:
              <ul>
                <li>Electronic newsletters with offers and general information.</li>
                <li>Discount coupons from us.</li>
                <li>General Offers by regular mail, email, SMS, Mobile Application/Website (through push notifications), social media, coupons, or any other digital channels used by you.</li>
              </ul>
              You can at any time stop receiving offers and information by opting out via the Mobile Application/Website. We will delete or render anonymous any of your personal data that has ever been stored by us. However, we shall continue to maintain a database of the users who have chosen to opt out along with their reasons for the same.
            </p>
            <p>
              <span className="bold">4.3. Analytics</span><br />
              In order to be able to provide you our services to the best of our ability, we shall need to understand and analyse your information and preferences. For the same, we shall analyse:
              <ul>
                <li>Your use of the Mobile Application/Website and e-mails you receive from us.</li>
                <li>Your participation in promotions.</li>
                <li>Your responses to surveys.</li>
                <li>Technical and functional management of the Mobile Application/Website, including IP address, location (if consented), and page visit details.</li>
              </ul>
            </p>
            <p>
              <span className="bold">4.4. Marketing and Research</span><br />
              We perform research into market trends through statistical or other analysis. We use the results of such research to evaluate our current services and to adapt our marketing and services to new developments. The research results are only reported on an aggregate basis.
            </p>
          </section>

          {/* Section 5: Access to Your Data */}
          <section className="section">
            <h2>5. Access to Your Data</h2>
            <p>
              <span className="bold">5.1.</span> We shall not disclose your personal data unless necessary. However, your personal data in a readable or non-readable format might be shared with:
              <ul>
                <li>Any agents, service providers, and/or subcontractors of Sharada Stores and its affiliates; and</li>
                <li>Any person to whom Sharada Stores proposes to transfer any of its rights and/or duties.</li>
              </ul>
            </p>
            <p>
              <span className="bold">5.2.</span> We also use third parties for certain processes. The collected personal data may be transferred to authorized third parties, which may be located outside of the Republic of India as part of the services offered to you. As far as these third parties have access to personal data, we have taken the required organizational and/or contractual measures to ensure that your personal data is exclusively processed for the purposes mentioned above.
            </p>
            <p>
              <span className="bold">5.3.</span> Except as set out in this Privacy Policy, we will not disclose any personal data without your permission unless we are legally entitled or required to do so or if we believe that such action is necessary to protect and/or defend our rights, property, or personal safety and those of our users/customers or other individuals.
            </p>
          </section>

          {/* Section 6: How We Share Information */}
          <section className="section">
            <h2>6. How We Share Information</h2>
            <p>
              <span className="bold">6.1. Service Providers and Partners</span><br />
              We use third parties to help us operate and improve our services. These third parties assist us with various tasks, including data hosting and maintenance, analytics, customer care, marketing, advertising, payment processing, and security operations. We may also share limited information in hashed, non-human readable form to advertising partners.
            </p>
            <p>
              <span className="bold">6.2. For Corporate Transaction(s)</span><br />
              In case we are involved in a merger, sale, acquisition, divestiture, restructuring, reorganization, dissolution, bankruptcy, or other change of ownership or control, we shall share your both personal and non-personal information.
            </p>
            <p>
              <span className="bold">6.3. For Legal Purpose(s)</span><br />
              We may disclose your information without your permission to comply with a legal process, assist in the prevention or detection of crime, or protect the safety of any person.
            </p>
          </section>

          {/* Section 7: Usage of Cookies */}
          <section className="section">
            <h2>7. Usage of Cookies</h2>
            <p>
              <span className="bold">7.1.</span> The Mobile Application/Website uses cookies or similar technology as required. A cookie is a small text file that is sent to your internet browser/app so that we are able to recognize you when you return.
            </p>
            <p>
              <span className="bold">7.2.</span> Using these technologies, we can collect data on the use of the Mobile Application/Website such as which pages are visited, your interaction with information, and the duration of your visit.
            </p>
            <p>
              <span className="bold">7.3. Functional Cookies</span><br />
              We store cookies that are essential in providing the functionalities of the Mobile Application/Website, such as remembering your preferences.
            </p>
            <p>
              <span className="bold">7.4. Web Analytics Cookies</span><br />
              We may use third-party cookies for web analysis to understand the way you use the Mobile Application/Website.
            </p>
            <p>
              <span className="bold">7.5. Advertising Cookies</span><br />
              We may use third-party cookies for advertising purposes to identify your device and serve relevant ads.
            </p>
            <p>
              <span className="bold">7.6.</span> We use session cookies and permanent cookies. Session cookies are deleted when you close the browser, while permanent cookies remain until deleted by you.
            </p>
          </section>

          {/* Section 8: How We Protect Your Information */}
          <section className="section">
            <h2>8. How We Protect Your Information</h2>
            <p>
              <span className="bold">8.1.</span> We have implemented industry-level secure technology and policies to protect your privacy from unauthorized access and improper use. However, we cannot assure complete safety of your personal information.
            </p>
            <p>
              <span className="bold">8.2.</span> We regularly monitor our systems for possible vulnerabilities and attacks and may suspend your account without notice if we suspect or detect any breach of security.
            </p>
          </section>

          {/* Section 9: Retention of Your Data */}
          <section className="section">
            <h2>9. Retention of Your Data</h2>
            <p>
              By deleting the Mobile Application/Website, we will close the applicable accounts as soon as reasonably possible. Personal data from closed or deactivated accounts will be deleted or rendered anonymous as soon as is reasonably possible, except in cases required by law.
            </p>
          </section>

          {/* Section 10: Children's Privacy */}
          <section className="section">
            <h2>10. Children's Privacy</h2>
            <p>
              Our services are restricted to users who are 18 years of age or older. We do not permit users under the age of 18 on our platform and we do not knowingly collect personal information from anyone under the age of 18.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;